import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { ELoadStatus } from '../../../../../state/state.interface';
import { IGetManyResponse } from '../../../../../utilities/http-utilities.service';

export interface IFormField {
  key: string;
  label: string;
  type: string;
}

export interface IFormFieldDropdownState {
  data: IFormField[];
  dataLoadStatus: ELoadStatus;
}

@Injectable()
export class FormFieldDropdownStore extends ComponentStore<IFormFieldDropdownState> {
  private readonly http = inject(HttpClient);

  public readonly formFields = this.selectSignal((state) => state.data);
  public readonly areFormFieldsLoaded = this.selectSignal((state) => state.dataLoadStatus === ELoadStatus.success);

  public readonly loadFormFields = this.effect<number>((trigger$) => {
    return trigger$.pipe(
      switchMap((id) => {
        this.patchState(({ dataLoadStatus }) => ({
          dataLoadStatus: dataLoadStatus === ELoadStatus.initial ? ELoadStatus.initialLoad : ELoadStatus.loading,
        }));

        return this.getWidgetRequests(id).pipe(
          tapResponse(
            ({ data }) => {
              this.patchState({
                data: data.filter(({ type }) => type === 'number'),
                dataLoadStatus: ELoadStatus.success,
              });
            },
            (_) => {
              this.patchState({
                dataLoadStatus: ELoadStatus.failure,
              });
            },
          ),
        );
      }),
    );
  });

  constructor() {
    super({
      data: [],
      dataLoadStatus: ELoadStatus.initial,
    });
  }

  public getWidgetRequests(id: number): Observable<IGetManyResponse<IFormField>> {
    return this.http.get<IGetManyResponse<IFormField>>(`forms/${id}/fields`);
  }
}
